import React from 'react'
import {BsLinkedin} from 'react-icons/bs'
import {BsInstagram} from 'react-icons/bs'
import {BsTwitter} from 'react-icons/bs'
import {BsDribbble} from 'react-icons/bs'
const header_social = () => {
    return (
        <div className='header_socials'>
            <a href="https://dribbble.com/mrnshv"  target="_blank" rel="noreferrer"> <BsDribbble/></a>
            <a href="https://www.instagram.com/erinevenight/" target="_blank" rel="noreferrer"><BsInstagram/></a>
            <a href="https://twitter.com/designerdebby" target="_blank" rel="noreferrer"><BsTwitter/></a>
            <a href="https://www.linkedin.com/in/anoshaahmed/" target="_blank" rel="noreferrer"><BsLinkedin/></a>
        </div>
    )
}

export default header_social
